var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"p-2"},[_c('deals-by-creator'),_c('deals-by-lead-board')],1)}
var staticRenderFns = []

export { render, staticRenderFns }